(() => {
  const initCarousel = (root) => {
    if (root.dataset.aaReady === 'true') return;
    root.dataset.aaReady = 'true';

    const track = root.querySelector('[data-aa-track]');
    const prev = root.querySelector('[data-aa-prev]');
    const next = root.querySelector('[data-aa-next]');
    if (!track) return;

    const scrollByCard = (dir) => {
      const card = track.querySelector('.aa-arogya__card');
      const amount = card ? card.getBoundingClientRect().width + 16 : 220;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    };

    prev?.addEventListener('click', () => scrollByCard(-1));
    next?.addEventListener('click', () => scrollByCard(1));

    const syncNav = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };

    track.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);
    syncNav();

    root.querySelectorAll('[data-aa-add]').forEach((btn) => {
      btn.addEventListener('click', async (event) => {
        event.preventDefault();
        const id = Number(btn.getAttribute('data-variant-id'));
        if (!id) return;

        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        try {
          const res = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
          });

          if (!res.ok) throw new Error('Add failed');

          btn.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));

          // Open cart drawer / bubble if theme supports it
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer?.open) {
            cartDrawer.open();
          } else {
            const cartIcon = document.querySelector('#cart-icon-bubble, .header__icon--cart, cart-icon-bubble');
            cartIcon?.click?.();
          }

          setTimeout(() => {
            btn.textContent = original;
            btn.disabled = false;
          }, 1200);
        } catch (err) {
          window.location.href = `/cart/add?id=${id}&quantity=1`;
        }
      });
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-aa-carousel]').forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
